export { cacheAdapterEnhancer as default } from 'choerodon-ui/dataset';
